import _ from 'lodash';
import moment from 'moment';
import {writable} from 'svelte/store';
import storage from './storage.js';

// хранилище параметров
const PARAMETERS = {};
export const parameter = (key, defaults = '') => {
    if (PARAMETERS[key]) {
        return PARAMETERS[key];
    }
    const store = writable(defaults);
    
    return PARAMETERS[key] = store;
};

export const network = {
    // request section
    
    request: async (data) => {
        let param = {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
            domain: 'https://api.trademaster.pro/plisse/',
            endpoint: '',
            params: null,
            body: null,
        };
        data = _.extend(param, data);
    
        let url = data.domain + data.endpoint + '?apikey=' + APP_KEY + (data.params ? '&' + data.params : '');
        let response = await fetch(url, {
            method: data.method.toUpperCase(),
            headers: data.headers,
            cache: 'no-cache',
            body: data.body
        });
        
        return await response.json();
    },
    
    get: async (endpoint, data) => {
        return await network.request({method: 'post', endpoint, params: (new URLSearchParams(data)).toString()});
    },
    
    post: async (endpoint, data) => {
        return await network.request({method: 'post', endpoint, body: formdata});
    },
    
    // * request section
    // proxy section
    
    proxy: async (query, isOne = false) => {
        let fd = new FormData();
            fd.append('query', query.trim());
        
        if (isOne) {
            fd.append('one', 'true');
        }
    
        let url = 'https://api.trademaster.pro/proxy?apikey=' + APP_KEY;
        let response = await fetch(url, {method: 'POST', cache: 'no-cache', body: fd});
        
        return await response.json();
    },
    
    getOrderList: async (user_id, user_kontr, user_sklad) => {
        let
            date1 = moment().subtract(1, 'year').format('YYYY-MM-DD'),
            date2 = moment().add(1, 'days').format('YYYY-MM-DD');
    
        const query = `
            EXEC viborkiAktualDateApp
                @idUser=${user_id},
                @idKontr=${user_kontr},
                @idSklad=${user_sklad},
                @data1='${date1}',
                @data2='${date2}'
        `;
        
        return await network.proxy(query);
    },
    
    getOrder: async (params) => {
        const query1 = `
            EXEC viborkaActual
                @nomer = '${params.id}',
                @vid = 16,
                @all = 1
        `;
        const query2 = `
            EXEC getTV @idSklad = 0
        `;
        const query3 = `
            EXEC kontakti @idKontr = ${params.user_kontr}
        `;
        
        return {
            order: await network.proxy(query1, true),
            tv: await network.proxy(query2),
            kontakti: await network.proxy(query3),
        };
    },
    
    saveKontakt: async (params) => {
        let query = '';
        
        if (params.idKontakt) {
            query = `
                EXEC saveKontakt
                    @idKontakt = '${params.idKontakt}',
                    @idKontr = '${params.user_kontr}',
                    @nameKontakt = '${params.nameKontakt}',
                    @fioKontakt = '',
                    @adresKontakt = '${params.adresKontakt}',
                    @telefonKontakt = '${params.telefonKontakt}',
                    @shemaKontakt = 0,
                    @other1Kontakt = '${params.other1Kontakt}',
                    @other2Kontakt = '${params.other2Kontakt}',
                    @actualnost = '${params.actualnost}'
            `;
        } else {
            query = `
                EXEC addKontakts
                    @idKontr = '${params.user_kontr}',
                    @nameKontakt = '${params.nameKontakt}',
                    @fioKontakt = '',
                    @adresKontakt = '${params.adresKontakt}',
                    @telefonKontakt = '${params.telefonKontakt}',
                    @shemaKontakt = 0,
                    @other1Kontakt = '${params.other1Kontakt}',
                    @other2Kontakt = '${params.other2Kontakt}'
            `;
        }
    
        let result = await network.proxy(query, true),
            idKontakt = (result.idKontakt ? result.idKontakt : -1);
    
        query = `
            EXEC viborkaUpdateKont
                @nom = '${params.nom}',
                @vid = '${params.vid}',
                @idKontakt = '${idKontakt}'
        `;
        
        return await network.proxy(query, true);
    },
    
    saveDelivery: async (params) => {
        let query = `
            EXEC viborkaUpdateTipDostTV
                @nom = '${params.nom}',
                @vid = '${params.vid}',
                @tv = '${params.tv}',
                @tipDost = '${params.dost}'
        `;
    
        return await network.proxy(query, true);
    },
    
    createTovar: async (params) => {
        const query = `
            EXEC addTovarViborka
                @name = '${params.name}',
                @opis = '${params.description}',
                @artikul = '${params.material}',
                @edIzmer = 'шт.',
                @vStrukture= '2',
                @foto_small = '',
                @ind1 = '${params.vin}',
                @ind2 = '${params.item}',
                @ind3 = '',
                @ind4 = '',
                @ind5 = '',
                @komment = '${params.problem}',
                @idSklad = ${params.user_sklad},
                @urlico = 0,
                @idKontr = ${params.user_kontr},
                @userId = ${params.user_id}
        `;
    
        return await network.proxy(query, true);
    },

    getMaterial: async () => {
        const query = `
            EXEC getMaterial
                @vstr = 1
        `;
        
        return await network.proxy(query);
    },
    
    // * proxy section
    // cdn section
    
    cdn: async (formdata) => {
        let url = 'https://api.trademaster.pro/cdn/post?apikey=' + APP_KEY;
        let response = await fetch(url, {method: 'POST', body: formdata});
        
        return await response.json();
    },
    
    // * cdn section
    // api section
    
    api: async (body = [], params = null) => {
        let url = 'https://app.bashdiesel.ru/api/chat.php' + (params ? '?' + (new URLSearchParams(params)).toString() : '');
        let response = await fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
            cache: 'no-cache',
            body: JSON.stringify(body),
        });
    
        return await response.json();
    },
    
    getChatMessages: async (order_id, user_id, last_msg_id) => {
        return await network.api([], {method: 'read', order: order_id, user: user_id, last_msg_id});
    },
    
    getChatMessagesCount: async (order_ids, user_id) => {
        return await network.api([], {method: 'count', orders: (Array.isArray(order_ids) ? order_ids.join('|') : order_ids), user: user_id});
    },
    
    sendChatMessage: async (order_id, user_id, user_name, message, type) => {
        return await network.api([], {method: 'write', order: order_id, user: user_id, name: user_name, message, type});
    },
    
    sendChatToken: async (token) => {
        const user = store('credential', 'getAuth'),
              user_id = user.get().id;
        
        return await network.api([], {method: 'save_token', user: user_id, token});
    }
    
    // * api section
}

// работа с хранением данных
const STORES = {};
export const store = (name, endpoint = null, value = '{}') => {
    if (STORES[name]) {
        return STORES[name];
    }
    
    let loading = writable(false),
        data = writable(JSON.parse(storage.getItem(name) ?? value));
    
    async function load(params) {
        if (endpoint) {
            loading.set(true);
            
            let result = await network.get(endpoint, params);
            if (result) {
                data.set(result);
                storage.setItem(name, JSON.stringify(result));
            } else {
                data.set({});
            }
            loading.set(false);
            
            return result;
        }
        
        return false;
    }
    
    function set(params) {
        data.set(params);
        storage.setItem(name, JSON.stringify(params));
    }
    
    function get() {
        let $val;
        data.subscribe($ => $val = $)();
        
        return $val;
    }
    
    function remove() {
        data.set('');
        storage.removeItem(name);
    }
    
    return STORES[name] = {
        subscribe: data.subscribe,
        get: get,
        set: data.set,
        update: data.update,
        load: load,
        loading: () => loading,
        save: set,
        remove: remove,
    };
};
